import { Reducer } from 'redux';

import { IUserEdge } from 'stubs/graphql/user';

import { ACCOUNT_ACTIONS, IAccountActions } from './actions';

export interface IAccountStore {
  loggedIn: boolean;
  me: IUserEdge;
}

export const initialState: IAccountStore = {
  loggedIn: false,
  me: {
    node: {
      id: 0,
      username: '',
      mobile: '',
      email: '',
      lastName: '',
      joinDate: new Date(),
      points: 0,
    },
  },
};

// --------------
// Reducer
// --------------

export const accountReducer: Reducer<IAccountStore, IAccountActions> = (
  state: IAccountStore = initialState,
  action: IAccountActions
) => {
  switch (action.type) {
    case ACCOUNT_ACTIONS.SET_LOGGED_IN:
      return { ...state, loggedIn: true };
    case ACCOUNT_ACTIONS.SET_LOGGED_OUT:
      return initialState;
    case ACCOUNT_ACTIONS.UPDATE_ME:
      return { ...state, me: action.me };
    case ACCOUNT_ACTIONS.RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
